export default {"src":"/_next/static/media/beach.9ec5d3dd.svg","height":82,"width":88,"blurWidth":0,"blurHeight":0};